<template>
	<div class="productcenter">
			<div class="img">
				<img :src="banner"/>
			</div>
			<!--路径-->
			<div class="container">
				<div class="navBar clearfix">
					<div class="path">
						<el-breadcrumb separator-class="el-icon-arrow-right">
						  	<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
						  	<el-breadcrumb-item :to="{ path: '/ProductCenter' }">产品中心</el-breadcrumb-item>
					  		<el-breadcrumb-item>{{detailData.name}}</el-breadcrumb-item>
						</el-breadcrumb>
					</div>
					<div class="itemBtn" @click="showItem()"><i class="el-icon-menu"></i></div>
				</div>
				<!--内容-->
				<div class="content clearfix">
					<div class="itemList" @click="hideItem()" v-if="showBox">
						<div class="content-left">
							<el-col style="border: 1px solid #dfdfdf;">
								<el-menu
								default-active="2"
								class="el-menu-vertical-demo"
								:default-openeds="openeds"
								@open="handleOpen"
								@close="handleClose">
									<div v-for="(item,index) in navList" :key="index">
										<el-submenu v-if="item.children" :index="item.id">
											<template slot="title">
												<span @click="getData(item.id)" style="width:100%;display:block">{{item.name}}</span>
											</template>
											<el-menu-item v-for="child in item.children" :index="item.id+'-'+child.id">
												<span @click="getData(child.id)" style="width:100%;display:block">{{child.name}}</span>
											</el-menu-item>
										</el-submenu>
										<el-menu-item v-if="!item.children" :index="item.id">
											<span @click="getData(item.id)" slot="title">{{item.name}}</span>
										</el-menu-item>
									</div>
								</el-menu>
							</el-col>
						</div>
					</div>
					<div class="content-right">
						
						<div class="table">
							<div class="productImg">
								<el-carousel indicator-position="outside">
								    <el-carousel-item  v-for="item in detailData.img">
								      <img :src="item.imgUrl" style="width:100%" alt="">
								    </el-carousel-item>
								</el-carousel>
								<!-- <div class="swiper-container gallery-top" id="gallery">
								    <div class="swiper-wrapper">
								      	<div class="swiper-slide" v-for="item in detailData.img" :style="item.bugImg">
								      	</div>
								    </div>
								    <div class="swiper-button-next swiper-button-white"></div>
								    <div class="swiper-button-prev swiper-button-white"></div>
								</div>
								<div class="swiper-container gallery-thumbs" id="thumbs">
								    <div class="swiper-wrapper">
								      	<div class="swiper-slide" v-for="item in detailData.img" :style="item.bugImg">
								      	</div>
								    </div>
								</div> -->
							</div>
							<div class="message">
								<h1>{{detailData.name}}</h1>
								<p>产品型号：{{detailData.product_sn}}</p>
							</div>
							
							<div class="product clearfix">
								<el-tabs v-model="activeName2" type="card" @tab-click="handleClick">
								    <el-tab-pane label="产品描述" name="first" v-html="detailData.detail">
								    </el-tab-pane>
								    <el-tab-pane label="配置管理" name="second">
										<el-table
										    :data="detailData.parameter"
										    border
										    style="width: 100%">
										    <el-table-column
										      	prop="name"
										      	label="名称"
										      	width="130"
										      	align="center">
										    </el-table-column>
										    <el-table-column
										      	prop="parameter"
										      	label="规格"
										      	width="">
										    </el-table-column>
									  	</el-table>
								    </el-tab-pane>
								</el-tabs>
							</div>
							
						</div>
									
					</div>
					
				</div>
				
				
				
			</div>
			
		
	</div>
</template>

<script>
	import Swiper from "swiper";
	import "swiper/dist/css/swiper.min.css";
	export default {
		name:'',
		components:{},
		data(){
			return{
				msg:'productcenter',
				activeNames: ['1','2','3','4','5'],
				navList:[],
				detailData:[],
				activeName2: 'first',
				name:'产品描述',
				banner:'',
				openeds:[],
				showBox:false
			}
		},
		methods: {
	        handleOpen(key, keyPath) {
		        console.log(key, keyPath);
		    },
		    handleClose(key, keyPath) {
		        console.log(key, keyPath);
		    },
		    handleClick(tab, event) {
        		console.log(tab, event);
      		},
			getData(id){
				this.$router.push({
							name:'ProductCenter',
							params: {
				          		id:id,
				          	}
				        })
			},
			getItemList(){
				this.axios({
					method: 'get',
					url: this.GLOBAL.productItemApi,
					data: {}
				})
				.then((res) => {
					this.navList = res.data.data;
					for (var i = 0; i < this.navList.length; i++) {
						this.openeds.push(this.navList[i].id);
					}
					var arr = res.data.data[0];
				})
				.catch((err) => {
					console.log(err)
				})
			},
			getInfo(){
				var id = this.$route.query.id;
				this.axios({
					method: 'get',
					url: this.GLOBAL.productDetailApi+id,
					data: {}
				})
				.then((res) => {
					this.detailData = res.data.data;
					console.log(this.detailData);
					
				})
				.catch((err) => {
					console.log(err)
				})
			},
	      	selItem(item) {
				this.name = item.title;
				this.$router.push(item.rou);
			},
			getBanner(){
				this.axios({
					method: 'get',
					url: this.GLOBAL.getBannerApi+'5',
					data: {}
				})
				.then((res) => {
					this.banner = res.data.data.banner5;
				})
				.catch((err) => {
					console.log(err)
				})
			},
			showItem(){
				this.showBox = true;
			},
			hideItem(){
				this.showBox = false;
			}
	      	
	   	},
	   	mounted(){
	   		setTimeout(function(){
	   			var galleryThumbs = new Swiper('#thumbs', {
					spaceBetween: 10,
					slidesPerView: 4,
					watchSlidesVisibility: true,//防止不可点击
			    });
			    var galleryTop = new Swiper('#gallery', {
			      	spaceBetween: 10,
			      	navigation: {
			        	nextEl: '.swiper-button-next',
			        	prevEl: '.swiper-button-prev',
			      	},
			      	thumbs: {
			        	swiper: galleryThumbs
			      	}
			    });
			},1000);
 		},
	   created(){
	   		this.getBanner();
	   		this.getItemList();
	   		this.getInfo();
	   }
		
	}
	


</script>

<style lang="less" scoped="scoped">
@import url("../../../styles/main.less");
.productcenter{
	.img{
		width:100%;
		overflow:hidden;
		position:relative;
		.height(300);
		img{
			width: 150%;
			height: 100%;
			position:absolute;
			left:-20%;
		}
	}
	.container{
		.padding-left(20);
		.padding-right(20);
		.navBar{
			width:100%;
			.margin-top(20);
			.margin-bottom(20);
			.path{
				width:90%;
				float:left;
				span{
					color: #00A0FF;
					.line-height(80);
				}
			}
			.itemBtn{
				width:10%;
				float:right;
				text-align:right;
				.font-size(60);
				color:#999;
			}
		}
		.content{
			.margin-top(50);
			.margin-bottom(50);		
			position:relative;
			.itemList{
				width:100%;
				background:rgba(0,0,0,0.7);
				position:fixed;
				top: 0;
    			left: 0;
    			height:100%;
    			z-index:666;
				.content-left{
					position:fixed;
					display: inline-block;
					width: 50%;
					border-box:box-sizing;
					.font-size(20);
					top:0;
					right:0;
					z-index:999;
					height:100%;
					box-shadow:0 0 20px #444;
					p{
						width: 100%;
						.height(40);
						text-align: left;
						.line-height(40);
						.padding-left(40);
						.font-size(20);
						background: #229dfe;
						color: #fff;
					}
					.mosttitle{
						.font-size(24);
						.margin-left(15);
					}
					.clicklist{
						.font-size(20);
						.padding-left(20);
						.margin-top(5);
						.margin-left(5);
						cursor: pointer;
						.disc{
								display: inline-block;
								.width(5) ;
								.height(5);
								background: #146BFF;
								border-radius: 50%;
								.margin-right(10);
								.margin-bottom(3);
							}
					}
					
				}
			}
			
			.content-right{
				display: inline-block;
				width: 100%;
				.table{
					width: 100%;
					.productImg{
						display: inline-block;
						width:100%;
						.padding(20,20,20,20);
						img{
							width: 100%;
							border-radius: 5px;
						}
						.NewHand{
							.margin-top(30);
							.swiper-wrapper{
								.swiper-slide{
									margin-left: 15px;
									img{
										.width(75);
										.height(80);
										.margin-right(10);
									}
									
								}
							}
						}
					}
					.message{
						display: inline-block;
						width: 100%;
						.font-size(30);
						h1{
							.font-size(50);
							.margin-top(20);
							font-weight:600;
							.margin-bottom(30);
						}
						h3{
							.font-size(30);
							.margin-bottom(30);
						}
					}
					.product{
						.margin-top(20);
						width: 100%;
						.padding(20,20,20,20);
					}
				}
			}
		}
	}
	
	.el-menu{
		border:0px;
	}
}

</style>


// WEBPACK FOOTER //
// src/components/pages/ProductCenter/ProDetail.vue